export const TEMPORARY_IMAGE = 'https://robohash.org/temp'
export const TEMPORARY_NAME = 'Wojciech Kruk'
export const TEMPORARY_EMAIL = 'wojciech.kruk@euvic.pl'
export const AVATAR_SIZE = 50
export const HORIZONTAL_SHIFT = 55
